import { smsDeepLink } from "../api";

interface Props {
  inboundNumber: string | undefined;
  body: string;
  label?: string;
}

// One-tap link that opens the device SMS composer prefilled with the login
// code. Renders nothing when no inbound number is available.
export function SmsLink({ inboundNumber, body, label = "SMS uygulamasında aç" }: Props) {
  const href = smsDeepLink(inboundNumber, body);
  if (!href) return null;
  return (
    <a className="sms-link" href={href}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
      </svg>
      {label}
    </a>
  );
}
